/**
 * Situação de rateio de cada UC e do cliente na tela de Débitos antigos (#6166).
 *
 * O cadastro (`unidades_consumidoras.situacao`) é a primeira fonte, mas não basta:
 * medido em 06/10/2026, 808 das 1.805 UCs estavam com a situação em branco, e
 * dívida antiga costuma estar em número ANTIGO de UC que nem tem cadastro (caso
 * Aurea Mariana: 10036699940 e 10030331259). A planilha mensal do rateio
 * (`rateios_credito_itens`) traz esses números e diz "Cancelada" mês a mês — é
 * ela que resolve esses casos. Cancelamento concluído na tela de Cancelamentos
 * também encerra.
 */

export const SITUACAO_CANCELADA = 'Cancelada';
/** Status da planilha de rateio: associado ativo, mas fora do rateio. */
export const SITUACAO_SEM_RATEIO = 'Ativa-S/-Rateio';

export type SituacaoRateioCliente = 'encerrado' | 'sem_rateio' | 'ativo' | 'nao_informada';

/**
 * Situação efetiva de uma UC.
 * - cancelamento concluído ou "Cancelada" na última planilha → Cancelada;
 * - cadastro em branco ou "Pausada" → vale o que a planilha disser;
 * - fora isso, o cadastro.
 */
export function situacaoEfetivaUc(
    cadastro: string | null | undefined,
    planilha: string | null | undefined,
    cancelamentoConcluido: boolean,
): string | null {
    const cad = (cadastro || '').trim() || null;
    const pla = (planilha || '').trim() || null;
    if (cancelamentoConcluido || pla === SITUACAO_CANCELADA) return SITUACAO_CANCELADA;
    if ((!cad || cad === 'Pausada') && pla) return pla;
    return cad;
}

/** Situação do cliente a partir das situações (já efetivas) das UCs da dívida. */
export function classificarRateioCliente(situacoes: Array<string | null | undefined>): SituacaoRateioCliente {
    const conhecidas = situacoes.map(s => (s || '').trim()).filter(Boolean);
    if (conhecidas.length === 0) return 'nao_informada';
    if (conhecidas.every(s => s === SITUACAO_CANCELADA)) return 'encerrado';
    if (conhecidas.every(s => s === SITUACAO_CANCELADA || s === SITUACAO_SEM_RATEIO)) return 'sem_rateio';
    return 'ativo';
}

const MESES = ['JAN', 'FEV', 'MAR', 'ABR', 'MAI', 'JUN', 'JUL', 'AGO', 'SET', 'OUT', 'NOV', 'DEZ'];
/** "AGO/2026" → número ordenável; inválido → -1. */
export function ordemMesReferencia(mes: string | null | undefined): number {
    const [abrev, ano] = String(mes || '').toUpperCase().split('/');
    const i = MESES.indexOf(abrev);
    const a = Number(ano);
    return i < 0 || !Number.isFinite(a) ? -1 : a * 12 + i;
}
